import { makeStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles(theme => ({
    root: {
        height: "calc(100vh - 252px)",
        overflowY: "scroll",
        paddingBottom: "1em",
        backgroundColor: theme.palette.grey[100],
    },
    skeletonContainer: {
        margin: "1em 5%",
    },
    button: {
        borderColor: theme.palette.info.light,
        color: theme.palette.info.main,
        fontSize: 14,
        fontWeight: 600,
    },
}));
